import { AjaxService, internalMessageBus, Cookies, EventsManager } from "../../externals";
import { LoginAPIRequestService, getTokenFromResponseV1, getTokenFromResponseV2 } from "../LoginAPIRequestService";
import { ApiVersion } from "../../types";
import { TokenHandler, CookiesStorage, TokenReader, TokenStream, TokenProcessingGateway, LogoutSubscription } from "../../common";
import { RequestGateway, RenewErrorHandler } from "../../common";
import { delay, getClock, makeTokenRequest } from "../../helpers";
import { PlatformJwtManager } from "../../PlatformJwtManager";
import { PlatformLoginSubscription } from "../PlatformLoginSubscription";
import { PlatformRequestGateway } from "../PlatformRequestGateway";
import { LegacyPlatformRequestGateway } from "../LegacyPlatformRequestGateway";
import { ResponsiveRequestService } from "../ResponsiveRequestService";
import { PlatformLoginResultHandler } from "../PlatformLoginResultHandler";
export const platformAuthContextFactory = (config) => {
    if (!getTokenFromResponse[config.apiVersion]) {
        throw `Not supported api version: ${config.apiVersion}`;
    }
    const tokenReader = new TokenReader(config.siteID, getClock(config.timeControl, config.initialTime));
    const tokenStorage = new CookiesStorage(tokenReader, Cookies, config);
    const tokenHandler = new TokenHandler(tokenStorage, internalMessageBus);
    const service = new LoginAPIRequestService(config.apiUrl, config.siteID.toString(), new AjaxService(), getTokenFromResponse[config.apiVersion], makeTokenRequest, config.getIovationKey);
    const errorHandler = new RenewErrorHandler(config.player, new EventsManager());
    const tokenStream = new TokenStream(service, tokenHandler, tokenReader, errorHandler);
    const tokenProcessingGateway = new TokenProcessingGateway(tokenStream);
    const gateway = new RequestGateway(service, tokenProcessingGateway, tokenStorage, tokenReader, delay);
    const platformJwtManager = new PlatformJwtManager(tokenStorage, config.player, tokenReader, gateway);
    const responsiveService = new ResponsiveRequestService(config.pageMethods);
    const loginResultHandler = new PlatformLoginResultHandler(config.player, responsiveService, gateway);
    const platformRequestGateway = new PlatformRequestGateway(service, gateway, loginResultHandler);
    const legacyPlatformRequestGateway = new LegacyPlatformRequestGateway(config.player, service, new ResponsiveRequestService(config.pageMethods), gateway);
    return {
        Gateway: gateway,
        PlatformJwtManager: platformJwtManager,
        Subscriptions: getSubscriptions(gateway, config, service, legacyPlatformRequestGateway, tokenReader),
        PlatformGateway: platformRequestGateway
    };
};
const getTokenFromResponse = {
    [ApiVersion.v1]: getTokenFromResponseV1,
    [ApiVersion.v2]: getTokenFromResponseV2
};
const getSubscriptions = (gateway, config, service, legacyPlatformRequestGateway, tokenReader) => [
    new LogoutSubscription(config.player, gateway, tokenReader),
    new PlatformLoginSubscription(config.player, legacyPlatformRequestGateway)
];
//# sourceMappingURL=PlatformAuthContextFactory.js.map